import buttonUp from '@/assets/btn/up.png';
import { Sound } from '@/classes';
import { useExtendFocusable } from '@/hooks/useExtendFocusable';
import { useFocusElement } from '@/hooks/useFocusElement';
import { isFocusScrollSuppressed, scrollElementTo } from '@/utils';
import { setFocus } from '@noriginmedia/norigin-spatial-navigation';
import { useCallback } from 'react';

export type GoToTopButtonProps = {
  onLeft?: boolean;
  focusKey?: string;
  scrollingRef?: React.RefObject<HTMLDivElement | null>;
};

export const GoToTopButton = ({ onLeft = false, focusKey, scrollingRef }: GoToTopButtonProps) => {
  const { ref, focused } = useExtendFocusable({
    onFocus: ({ x, top }) => {
      if (isFocusScrollSuppressed('vertical')) {
        return;
      }

      if (scrollingRef && !onLeft) {
        if (scrollingRef?.current) {
          scrollElementTo({ element: scrollingRef.current, left: x, top });
        }
      }
    },
    focusKey: 'footer',
  });

  const handleOnClick = useCallback(() => {
    if (!scrollingRef) return;

    Sound.press();

    if (scrollingRef?.current) {
      scrollElementTo({ element: scrollingRef.current, top: 0 });
    }

    if (focusKey) {
      setFocus(focusKey);
    }
  }, [scrollingRef, focusKey]);

  useFocusElement({ ref, focused: focused, onClick: handleOnClick, keyCode: 13 });

  if (onLeft) {
    return (
      <div className="flex w-full justify-center relative">
        <div
          ref={ref}
          tabIndex={0}
          className="fixed bg-[#FFF3F9] rounded-full p-3 outline-disable outline-primary-fill-8 top-[589px] left-[54px]"
          onClick={handleOnClick}
          onContextMenu={handleOnClick}
        >
          <img src={buttonUp} className={`w-auto h-auto`} />
        </div>
      </div>
    );
  }

  return (
    <div className="flex w-full justify-center items-center mt-[80px] mb-[100px]">
      <div
        ref={ref}
        tabIndex={0}
        className="bg-[#FFF3F9] rounded-full p-3 outline-disable outline-primary-fill-8"
        onClick={handleOnClick}
        onContextMenu={handleOnClick}
      >
        <img src={buttonUp} className={`w-auto h-auto`} />
      </div>
    </div>
  );
};
